
export default{
    computed: {
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    methods: {
        resize(){
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
        })
        }

    }
}